import { useEffect, useState, useRef } from 'react';

const useDocumentVisibility = (onVisibilityChange, delay = 0) => {
  const isDocumentDefined = typeof document !== 'undefined';
  const [isVisible, setIsVisible] = useState(isDocumentDefined ? !document.hidden : true);
  const hiddenAtRef = useRef(null);
  const timeoutRef = useRef(null);
  const onVisibilityChangeRef = useRef(onVisibilityChange);

  useEffect(() => {
    onVisibilityChangeRef.current = onVisibilityChange;
  }, [onVisibilityChange]);

  useEffect(() => {
    if (!isDocumentDefined) {
      return () => {};
    }

    const clearTimeoutRef = () => {
      if (timeoutRef.current !== null) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
    };

    const handleVisibilityChange = () => {
      const isDocVisible = !document.hidden;
      setIsVisible(isDocVisible);

      if (!isDocVisible) {
        hiddenAtRef.current = Date.now();
        clearTimeoutRef();
      } else {
        const hiddenDuration = hiddenAtRef.current ? Date.now() - hiddenAtRef.current : 0;

        if (hiddenDuration >= delay) {
          if (typeof onVisibilityChangeRef.current === 'function') {
            onVisibilityChangeRef.current(isDocVisible);
          }
        }
        hiddenAtRef.current = null;
        clearTimeoutRef();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      clearTimeoutRef();
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [delay, isDocumentDefined]);

  return isVisible;
};

export default useDocumentVisibility;
